import React from 'react';

const NamingPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/naming',
			exact: true,
			component: React.lazy(() => import('./NamingPage')),
		},
	],
};

export default NamingPageConfig;
